import request from "@/utils/request";
import { buildRequestPath } from "@/utils/uploadUrl";

export function getSearch(uid) {
  return request.get('/search/keyword/'+uid, {},{ login: false });
}
export function deleteSearch(params) {
  return request.post('/search/del',params, { login: true });
}
export function getArtIndex(params) {
  return request.get('/index/web/0', params, { login: false });
}
export function getArtCategoryList(params) {
  return request.get('/web/category/list', params, { login: false });
}

export function artCoursePromote(params) {
  return request.get('/promote/artCoursePromote', params, { login: false });
}

export function artCategoryCourse(params) {
  return request.get('/artCourse/list', params, { login: false });
}

export function uploadImg(params){
  return request.post(buildRequestPath('/api/upload'),params, { login: true });
}
export function uploadVideo(params){
  return request.post(buildRequestPath('/api/upload/video'),params, { login: true });
}
export function feedBackSubmit(params){
  return request.post('/feedBack/submit',params, { login: true });
}
/*
 * 问题列表
*/
export function getfeedBackCategory  (data){
  return request.get('/feedBack/category',data, { login: false });
}

/*
 * 隐私策略
*/
export function privacyPolicy(id){
  return request.get('/privacyPolicy/details/'+id,{}, { login: true });
}
